module.exports = __webpack_public_path__ + "assets/group_icon.8f2819ea.svg";